import $ from 'jquery';
import { SuperGif } from '@wizpanda/super-gif';

export function handleOutputGifs($container) {
  // There's no way to resume an existing SuperGif canvas so just swap the canvas with the
  // original image and it'll get rebuilt in the next step
  const $outputCanvas = $container.find('.codex-output .super-gif canvas');
  if ($outputCanvas.length) {
    $outputCanvas.each((index, canvas) => {
      const $listItem = $(canvas).parents('li');
      const image = document.createElement('img');
      image.src = $listItem.data('gif-source');
      $listItem.empty().append($(image));
    });
  }

  // Initialize gif output images
  const $outputGif = $container.find('.codex-output img[src*=".gif?t="]');
  if ($outputGif.length) {
    $outputGif.each((index, image) => {
      const $image = $(image);
      const initGifPlayer = () => {
        const $replayButton = $(`
                    <button class="replay-button">
                        <span class="btn">Replay</span>
                    </button>
                `);

        const gif = new SuperGif(image, {
          autoPlay: false,
          drawWhileLoading: false,
          // This needs to be < image width to avoid being huge on hdpi screens
          maxWidth: image.width - 1,
          onEnd: () => {
            $replayButton.prop('disabled', false);
            gif.pause();
          },
        });

        // Attach the gif url to the canvas so we can recreate the gif later
        $image.parents('li').attr('data-gif-source', image.src);

        const src = `${image.src}&d=${Date.now()}`;

        gif.loadURL(src, () => {
          const { canvas } = gif;
          const $canvas = $(canvas);

          $replayButton.css({
            width: canvas.width,
            height: canvas.height,
          });

          const replayGif = () => {
            if (!gif.playing) {
              gif.moveTo(0);
              gif.play();
              $replayButton.prop('disabled', true);
            }
          };

          $canvas.on('click', replayGif);

          $replayButton.prop('disabled', true);
          $replayButton.on('click', e => {
            e.preventDefault();
            replayGif();
          });

          $canvas.after($replayButton);

          gif.play();
        });
      };

      if (image.complete) {
        initGifPlayer();
      } else {
        $image.on('load', initGifPlayer);
      }
    });
  }
}
